import { COLORS } from "./theme";

export const DEFAULT_SNACK = {
  severity: COLORS.DARK,
  message: "",
  visible: false,
};

export const ERROR_CREDENTIALS = {
  severity: COLORS.ERROR,
  message: "Acceso inválido",
  visible: true,
};

export const SUCCESS_CREDENTIALS = {
  severity: COLORS.SUCCESS,
  message: "Acceso válido",
  visible: true,
};

export const EMPTY_CREDENTIALS = {
  severity: COLORS.ERROR,
  message: "Campo vacío, debes completar todos los campos",
  visible: true,
};

export const SUCCESS_REGISTER = {
  severity: COLORS.SUCCESS,
  message: "Usuario creado",
  visible: true,
};

export const ERROR_REGISTER = {
  severity: COLORS.ERROR,
  message: "Error al crear el usuario",
  visible: true,
};

export const EXISTING_USER = {
  severity: COLORS.ERROR,
  message: "Usuario existente",
  visible: true,
};

export const INVALID_EMAIL = {
  severity: COLORS.ERROR,
  message: "Correo invalido",
  visible: true,
};

export const SUCCESS_CAR_REGISTER = {
  severity: COLORS.SUCCESS,
  message: "Registro creado",
  visible: true,
};

export const ERROR_CAR_REGISTER = {
  severity: COLORS.ERROR,
  message: "Error al crear el registro",
  visible: true,
};

export const EXISTING_CAR = {
  severity: COLORS.ERROR,
  message: "Registro existente",
  visible: true,
};

export const SUCCESS_FORGOT = {
  severity: COLORS.SUCCESS,
  message: "Solicitud enviada",
  visible: true,
};

export const ERROR_FORGOT = {
  severity: COLORS.ERROR,
  message: "Error al enviar la solicitud",
  visible: true,
};

export const SUCCESS_RECOVERY = {
  severity: COLORS.SUCCESS,
  message: "Contraseña cambiada con éxito",
  visible: true,
};

export const ERROR_RECOVERY = {
  severity: COLORS.ERROR,
  message: "Error al cambiar la contraseña",
  visible: true,
};

export const NO_CHANGES = {
  severity: COLORS.ERROR,
  message: "No se hizo ningun cambio",
  visible: true,
};

export const ERROR_EDIT_PROFILE = {
  severity: COLORS.ERROR,
  message: "Error al efectuar cambios en el perfil",
  visible: true,
};

export const SUCCESS_EDIT_PROFILE = {
  severity: COLORS.SUCCESS,
  message: "Cambios del perfil guardados",
  visible: true,
};

export const DUPLICATE_LICENSE = {
  severity: COLORS.ERROR,
  message: "Placa patente ya registrada, buscar en historial",
  visible: true,
};

export const SUCCESS_CUSTOMER_REGISTER = {
  severity: COLORS.SUCCESS,
  message: "Cliente creado exitosamente",
  visible: true,
};

export const ERROR_CUSTOMER_REGISTER = {
  severity: COLORS.ERROR,
  message: "Error al crear el cliente",
  visible: true,
};

export const CUSTOMER_NOT_FOUND = {
  severity: COLORS.ERROR,
  message: "Cliente no encontrado",
  visible: true,
};

export const CUSTOMER_FOUND = {
  severity: COLORS.SUCCESS,
  message: "Cliente encontrado, datos autocompletados",
  visible: true,
};
